<template>
    <div class="row answers">
        <div class="col">
            <div class="row">
                <h2>Question answers</h2>
            </div>
            <div class="row question" v-for="(answer, index) in answers" :key="index">
                <div class="col">
                    <h3>Q{{index+1}}. {{getQuestion(index).question}}</h3>
                    <h4>Answer: {{answerContent(index, answer)}}</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AnswerList",
        computed: {
            answers() {
                return Object.values(this.$store.getters.getAnswers);
            },
            questions() {
                return this.$store.getters.getQuestions;
            },
        },
        methods: {
            answerContent(index, answerId) {
                return this.getQuestion(index).answers.find(item => {
                    return item.value === answerId
                }).answer;
            },
            getQuestion(index) {
                let questionIndex = index + +1;
                return this.questions[questionIndex];
            }
        }
    }
</script>

<style scoped lang="stylus">
    .answers
        margin-top 5rem

        .question
            margin 2rem

            h3
                margin 1rem 0

            h4
                color $color-blue-petrol
                font-family $font-bold
                font-size 1.8rem

</style>